export const pageRoutes = {
  rootPath: '/',
  dashboard: '/dashboard',
};
